import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

//ANT DESIGN IMPORTS
import {
  Input,
  Row,
  Typography,
  Card,
  Select,
  Form,
  DatePicker,
  Col,
  Divider,
  Button,
  Spin,
} from "antd";

//ANT DESIGN ICONS IMPORTS
import { LeftOutlined } from "@ant-design/icons";

//PROJECT IMPORTS
import { BOM } from "../../../services/definedMethod";
import cnt from "../../../services/definedConstant";
import MainLayout from "../../../components/layouts/MainLayout";
import TopContent from "../../../components/layouts/TopContent";
import { apiConfig, labelConfig, staticConfig } from "../configurations.config";
import CustomButton from "../../../components/custom/CustomButton";
import dayjs from "dayjs";

const { Text, Title } = Typography;
const { TextArea } = Input;

const NewPaymentType = (props) => {
  const { userData } = props;
  const { session } = userData;
  const navigate = useNavigate();
  const [useForm] = Form.useForm();
  const { state } = useLocation();
  const [officeOptions, setOfficeOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    useForm.setFieldsValue({
      isCashPayment: staticConfig.yesOrNo[1].value,
    });
  }, []);

  function onCancel() {
    navigate("/manage-payment-type", { state: state });
  }

  const onSubmit = (formValues) => {
    const body = {
      ...formValues,
      method: "POST",
      session,
    };

    // return
    setIsLoading(true);
    BOM.FetchReqAction(body, apiConfig.Paymenttypes, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.errors[0].defaultUserMessage);
        setIsLoading(false);
      } else {
        BOM.AlertMsg(cnt.SUCCESS, labelConfig.newPaymentTypeMsg);
        navigate("/manage-payment-type");
        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  return (
    <MainLayout isEnableRightSidebar={true}>
      {/* PART 1  IMPORT TOP CONTENT*/}
      <TopContent
        pageTitle={labelConfig.newPaymentType}
        pageItems={staticConfig.newPaymentTypeBreadcrumbItems}
      />

      <Spin spinning={isLoading} size="large">
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
          title={
            <Row
              style={{
                alignContent: "center",
                width: "8%",
              }}
            >
              <Button
                icon={<LeftOutlined />}
                type="text"
                style={{
                  marginTop: "auto",
                  marginBottom: "auto",
                }}
                onClick={onCancel}
              >
                <Text
                  style={{
                    marginTop: "auto",
                    marginBottom: "auto",
                    fontSize: 15,
                  }}
                >
                  Back
                </Text>
              </Button>
            </Row>
          }
        >
          <Form form={useForm} layout="vertical" onFinish={onSubmit}>
            <Row>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.paymentType}
                  name="name"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.paymentType),
                    },
                  ]}
                >
                  <Input
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.paymentType
                    )}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.isCashPayment}
                  name="isCashPayment"
                >
                  <Select
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.isCashPayment,
                      "select"
                    )}
                    options={staticConfig.yesOrNo}
                    showSearch
                    allowClear
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.position}
                  name="position"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.position),
                    },
                  ]}
                >
                  <Input
                    placeholder={BOM.handlePlaceholderMsg(labelConfig.position)}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item label={labelConfig.description} name="description">
                  <TextArea
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.description
                    )}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Divider />
              {BOM.HasPermission("CREATE_PAYMENTTYPE") && (
                <CustomButton
                  content="Submit"
                  style={{
                    width: "10%",
                    marginLeft: "auto",
                    boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                  }}
                  htmlType="submit"
                  backgroundColor="#92428B"
                  colorText="white"
                  hoverBackground="#AD4EA7"
                />
              )}

              <CustomButton
                content="Cancel"
                style={{
                  width: "10%",
                  marginLeft: "1%",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                backgroundColor="#fff"
                colorText="black"
                hoverBackground="#F5F5F5"
                onClick={onCancel}
              />
            </Row>
          </Form>
        </Card>
      </Spin>
    </MainLayout>
  );
};

export default NewPaymentType;
